import React from 'react';

export interface SurveyTabProps {
  onClick: Function
}

export default function SurveyTab({onClick}: SurveyTabProps) {
  return (
    <div className="flex flex-col z-10 justify-center items-center bg-novartis-blue h-36 w-8 fixed right-0 top-[40%] rounded-l-lg">
      <button
        type="button" 
        className="rotate-[270deg] font-bold text-font-contrast font-novartis" 
        onClick={() => onClick()}
      >
        Feedback
      </button>
    </div>
  )
}